export class AnnotationDialogDataParam {
    its4Student: boolean;
    studentId: string;
    courseId: string;
//    subjectId: string;
}